export enum InvoiceReportUrls {
  ReportAllRequest = "InvoiceReport/ReportAllRequest",
  ReportAllRequestAttachment = "InvoiceReport/ReportAllRequestAttachment",
  ReportInvoice = "InvoiceReport/ReportInvoice",
  ReportInvoiceArticle = "InvoiceReport/ReportInvoiceArticle",
  DailyAverageReport = "InvoiceReport/DailyAverageReport",
  Report = "InvoiceReport/Report",
  TurnoverReport = "InvoiceReport/TurnoverReport",
}
